/**
 * How a hunch reads in the room. Pure, so jest can check the wording without a
 * DOM.
 */
import type { BoardroomHunchRow } from '../../../types';

/** What checking it means, in words: a pains hunch is checked for complaints. */
export function checkLabel(check: string): string {
  switch (check) {
    case 'pains':
      return 'complaints';
    case 'players':
      return 'players';
    case 'demand':
      return 'search demand';
    default:
      return check || '-';
  }
}

/** "2 pains · 2 people" — for complaints, the people count is what makes it
 *  hold, so it is said; for players and demand, the rows are the answer. */
export function findingsLabel(row: Pick<BoardroomHunchRow, 'check' | 'findings' | 'voices'>): string {
  const n = row.findings.length;
  if (row.check === 'pains') {
    return `${n} ${n === 1 ? 'pain' : 'pains'} · ${row.voices} ${row.voices === 1 ? 'person' : 'people'}`;
  }
  if (row.check === 'players') return `${n} ${n === 1 ? 'player' : 'players'}`;
  return `${n} ${n === 1 ? 'reading' : 'readings'}`;
}

export function hunchStateTone(state: string): string {
  switch (state) {
    case 'supported':
      return 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300';
    case 'dead':
      return 'bg-gray-100 text-gray-500 dark:bg-gray-700 dark:text-gray-400';
    default:
      return 'bg-yellow-50 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300';
  }
}
